export default {
    PAGE: {
        COMMON: {
            EMAIL_LWK: '/emaillwk',
            ACCESS_DENIED: '/access-denied',
            WARTUNG: '/wartung',
            CONTACT: '/contact',
            ABOUT: '/about',
            DATENSCHUTZ: '/datenschutz',
            FACTS: '/facts',
            FAQ: '/faq',
            FORMS: '/forms',
            REQUIREMENTS: '/requirements',
            TERMS: '/terms',
        },
        NOT_FOUND: '/',
    },
    API: {
        USER: '/current-user',
        CMS: '/stammdaten/cms/:page',
        BETRIEB: '/betriebe/:betrieb_nr',
        EZZ_BETRIEBE: '/betriebe/ezz',
        STAMMDATEN: {
            AREA: '/stammdaten/gemarkung',
            REBSORTE: '/stammdaten/rebsorte',
            UNTERLAGE: '/stammdaten/unterlage',
            FLURBEREINIGUNG: '/stammdaten/flurbereinigung',
            QTYP: '/stammdaten/qtyp',
        },
        LOG: {
            REPORT: '/log/frontend-log/:category',
        },
        EMAIL_LWK_CHECK: '/user/email-lwk/check',
        EMAIL_LWK_SEND: '/user/email-lwk/send',
    },
};
